export function setCssVar(iframe: HTMLIFrameElement, varName: string, value: string) {
  iframe.contentDocument?.body.style.setProperty(`--${varName}`, value);
}